export class AddContactInfoCustomFieldHeaderResultDto {
  fieldName: string;
  caption: string;
}
